export var ExprState;
(function (ExprState) {
    ExprState["Parsed"] = "PARSED";
    ExprState["Compiled"] = "COMPILED";
})(ExprState || (ExprState = {}));
